import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import theme from './StandardReplies.module.scss';
import SimpleFormPage from '@/components/SimpleFormPage/SimpleFormPage';
import StandardRepliesEmpty from './StandardRepliesEmpty';
import SearchInput from '@/components/SearchInput';
import { Button } from '@/components/Buttons';
import StandardReplyCard from './StandardReplyCard';
import { getStandardRepliesByProfileId } from '@/services/standard-replies';
import { searchByFields } from '@/services/search';
import EditStandardReplyModal from './EditStandardReplyModal';
import { useAsyncState } from '@/utils/hooks';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

interface StandardRepliesPageProps {
    profileId: number;
}

const StandardRepliesPage: React.FC<StandardRepliesPageProps> = ({ profileId }) => {
    const [newStandardReplyModalIsOpen, setNewStandardReplyModalIsOpen] = useState(false);
    const [standardReplies, , reloadStandardReplies] = useAsyncState(
        () => getStandardRepliesByProfileId(profileId),
        [profileId],
        null
    );
    const [searchText, setSearchText] = useState('');

    return (
        <div>
            {standardReplies?.length === 0 && (
                <SimpleFormPage>
                    <StandardRepliesEmpty onCreate={reloadStandardReplies} />
                </SimpleFormPage>
            )}

            {standardReplies && standardReplies.length > 0 && (
                <div className={theme.standardRepliesContainer}>
                    <div className={theme.topComment}>
                        <Trans>
                            Create a message "template" that agents can use frequently. The template can then be added
                            directly to client messages.
                        </Trans>
                    </div>
                    <div className={theme.topBar}>
                        <div>
                            <label className={theme.search}>
                                <Trans>Search</Trans>
                            </label>
                            <SearchInput onSearchTextChange={(text) => setSearchText(text)} />
                        </div>
                        <Button onClick={() => setNewStandardReplyModalIsOpen(true)} color="primary" icon={faPlus}>
                            <Trans>Create new</Trans>
                        </Button>
                    </div>
                    {searchByFields(standardReplies, searchText, ['title', 'name', 'text', 'comment'])?.map(
                        (standardReply) => (
                            <StandardReplyCard
                                key={standardReply.id}
                                standardReply={standardReply}
                                onChange={reloadStandardReplies}
                            />
                        )
                    )}
                </div>
            )}

            <EditStandardReplyModal
                isOpen={newStandardReplyModalIsOpen}
                toggle={() => setNewStandardReplyModalIsOpen(false)}
                onSave={reloadStandardReplies}
            />
        </div>
    );
};

export default StandardRepliesPage;